import React from 'react'
import PropTypes from 'prop-types'

import UgcCarousel from '../../components/ugc-carousel'

/**
 * Adapts CMS-managed UGC carousel properties to the reusable carousel presentation.
 *
 * @param {Object} props - Module properties.
 * @returns {JSX.Element} The UGC carousel module.
 */
const UgcCarouselModule = React.forwardRef(function UgcCarouselModule(props, ref) {
    return <UgcCarousel {...props} ref={ref} />
})

UgcCarouselModule.propTypes = {
    moduleId: PropTypes.string,
    moduleType: PropTypes.string,
    pageId: PropTypes.string,
    headingLevel: PropTypes.number,
    alignment: PropTypes.oneOf(['left', 'center']),
    aspectRatio: PropTypes.string,
    heading: PropTypes.object,
    copy: PropTypes.object,
    cta: PropTypes.object,
    tiles: PropTypes.arrayOf(
        PropTypes.shape({
            asset: PropTypes.object,
            tag: PropTypes.shape({
                label: PropTypes.string,
                icon: PropTypes.shape({
                    name: PropTypes.string,
                    title: PropTypes.string,
                    alt: PropTypes.string
                })
            })
        })
    ),
    anchor: PropTypes.string,
    background: PropTypes.oneOf(['default', 'subtle', 'strong', 'inverse']),
    spacing: PropTypes.oneOf(['default', 'reduced', 'min', 'min-top', 'min-bottom'])
}

export default UgcCarouselModule
